// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

const MediaPlaceholder = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 100 800 685" {...props}>
    <path
      fill="#CCC"
      d="M45.9 695.5c-4.3 0-8-3.5-8-8v-482c0-4.3 3.5-8 8-8h708.5c4.3 0 8 3.5 8 8v481.8c0 4.3-3.5 8-8 8H45.9v.2z"
    />
    <path
      fill="#CCC"
      d="M752.3 207.7v477.9H47.7V207.7h704.6m1.8-20H45.9c-9.8 0-17.9 8-17.9 17.9v481.8c0 9.8 8 17.9 17.9 17.9h708.5c9.8 0 17.9-8 17.9-17.9V205.6c-.3-9.8-8.2-17.9-18.2-17.9z"
    />
    <path
      fill="#FFF"
      d="M8.5 680c-4.8 0-8.5-3.8-8.5-8.5V147.1c0-4.8 3.8-8.5 8.5-8.5h761.6c4.8 0 8.5 3.8 8.5 8.5v524.3c0 4.8-3.8 8.5-8.5 8.5H8.5v.1z"
    />
    <path
      fill="#808283"
      d="M778.7 146.6v520H21.3v-520h757.4m2.1-21.3H19.2C8.5 125.3 0 133.8 0 144.5v524.3C0 679.5 8.5 688 19.2 688h761.6c10.7 0 19.2-8.5 19.2-19.2V144.5c0-10.7-8.5-19.2-19.2-19.2z"
    />
    <path fill="#E7E7E7" d="M48.1 445.6v192h700.5v-72l-285-250.5-208.5 195" />
    <circle fill="#E7E7E7" cx="210.1" cy="289.6" r="54.7" />
  </svg>
);

export default MediaPlaceholder;



// WEBPACK FOOTER //
// ./src/components/Icons/MediaPlaceholder.js